import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type YourNumbersCardProps = ComponentProps<'div'>;

function YourNumbersCard({ className, ...props }: YourNumbersCardProps) {
  return (
    <div
      className={twMerge('flex w-full flex-col gap-4 overflow-clip rounded-2xl border border-border-active bg-background shadow-foreground shadow-[0_3px_0_0]', className)}
      {...props}
    />
  );
}

export { YourNumbersCard, type YourNumbersCardProps };
